import { authGateway } from "@/gateways/authGateway";
import type { MutationCallbacks } from "@/types";
import { useMutation } from "@tanstack/vue-query";

export function useVerifyLogin(callbacks: MutationCallbacks = {}) {
  const mutation = useMutation({
    mutationFn: async (code: string) => {
      try {
        await authGateway.verifyLogin(code.trim());
      } catch {
        throw new Error("Authentication failed");
      }
    },
    onSuccess() {
      callbacks.onSuccess?.();
    },
  });

  return {
    ...mutation,
    verifyLoginStatus: mutation.status,
    verifyLogin: mutation.mutate,
  };
}
